import type {Step} from "../../components/stepper/Step.ts";
import {useAtomValue} from "jotai";
import {WorkloadScanAtom} from "../2-scanning/WorkloadScanAtom.tsx";
import {CustomerResultsWidget} from "./CustomerResultsWidget.tsx";

export function useCustomerResultsStep(): Step {
    const scanResult = useAtomValue(WorkloadScanAtom)
    
    return {
        name: "Results",
        isCompleted: false,
        isAvailable: scanResult !== undefined,
        Widget: CustomerResultsWidget
    }
}
